type RightsDataQueryInput =
  | {
      metadata?: { ISRC?: string | null }
      name?: string | null
      artist?: string | null
    }
  | null
  | undefined

export const buildRightsDataQuery = (track: RightsDataQueryInput): string => {
  const q = new URLSearchParams()
  if (track?.metadata?.ISRC) q.set('isrc', track.metadata.ISRC)
  if (track?.name && track?.artist) {
    q.set('title', track.name)
    q.set('artist', track.artist)
  }
  const qs = q.toString()
  return qs ? `?${qs}` : ''
}
